/**
 * Halo icon — a tilted elliptical ring like a saint's nimbus.
 * Drop-in replacement for lucide-react icons (accepts className, size, etc.)
 */
export function HaloIcon({ className = "", size = 24, strokeWidth = 2, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      {/* Outer halo ring — tilted ellipse */}
      <ellipse cx="12" cy="9" rx="9.5" ry="3.5" transform="rotate(-8 12 9)" />
      {/* Inner highlight ring for depth */}
      <ellipse cx="12" cy="9" rx="7" ry="2.2" transform="rotate(-8 12 9)" opacity="0.4" />
    </svg>
  );
}
